var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5441_6106",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 71
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.253906 0.893555H69.5082V70.1478H0.253906V0.893555Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5441_6106)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.881 70.1473C15.8361 70.1473 0.253906 54.5651 0.253906 35.347C0.427042 16.3021 15.8361 0.719895 35.0542 0.893031C54.0991 1.06617 69.5082 16.4752 69.5082 35.8664C69.335 54.7382 53.926 70.1473 34.881 70.1473Z",
    fill: "#4B5158"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1704 31.3663L37.1316 36.9066L47.0003 38.2917L46.3078 40.8887L36.6122 39.5036C35.9196 41.7544 35.5733 44.1783 34.7077 46.2559C33.842 48.6798 32.9763 51.1037 31.9375 53.3545C30.5524 56.2978 28.1285 58.3754 24.8389 58.8948C22.9344 59.2411 20.8568 59.068 19.2986 57.856C18.7792 57.5097 18.2598 56.8172 18.2598 56.2978C18.2598 55.6053 18.606 54.7396 19.1254 54.3933C19.4717 54.2202 20.3374 54.3933 20.8568 54.5664C21.3762 55.0858 21.8956 55.7784 22.2419 56.4709C23.2807 57.856 24.6658 58.0292 26.0509 56.9903C27.6091 55.6053 28.4748 53.7008 28.9942 51.7963C30.033 47.641 31.0718 43.6589 31.9375 39.5036V38.8111L22.7613 37.426L23.1076 34.829L32.63 36.2141L33.842 30.8468L23.9732 29.2886L24.3195 26.5185L34.5345 27.9035C34.8808 26.8647 35.0539 25.9991 35.4002 25.1334C36.2659 22.0169 37.1316 18.9005 39.2092 16.1303C41.2868 13.3601 43.7107 11.6288 47.3466 11.8019C48.9048 11.8019 50.463 12.3213 51.5018 13.5333C51.675 13.7064 52.0212 14.0527 52.0212 14.399C52.0212 15.0915 52.0212 15.9572 51.5018 16.4766C50.8093 16.996 49.9436 16.8229 49.2511 16.1303C48.7317 15.6109 48.3854 15.0915 47.866 14.5721C46.8272 13.187 45.2689 13.0139 44.057 14.2258C43.1913 15.0915 42.3256 16.3035 41.8062 17.5154C40.5943 21.1513 39.7286 24.9602 38.5166 28.7692L48.0391 30.1543L47.3466 32.7513L38.1704 31.3663Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFil);
export default __webpack_public_path__ + "static/media/fil.31851c9c972abf4c8f9a5a37a515959a.svg";
export { ForwardRef as ReactComponent };